import React from "react";
import {Form} from 'react-bootstrap';


function STCFormSelect(props){

    return(
        <Form.Select 
            style={props.style}
            className={props.className}
            required={props.required}
            id={props.id}
            as={props.as}
            disabled={props.disabled}
            htmlSize={props.htmlSize}
            isInvalid={props.isInvalid}
            isValid={props.isValid}
            onChange={props.onChange}
            size={props.size}
            value={props.value}
            defaultValue={props.defaultValue}
            multiple={props.multiple}
            sm={props.sm}

        >{props.children}</Form.Select>
    )
}
export default STCFormSelect;